import React, { useContext, useEffect, useState } from "react"
import { MapControlContext } from "../MapControlContext"
 
const MeasureSelect = ({ control }) => {
    const { setControlOptions } = useContext(MapControlContext)
    const [selectedUnit, setSelectedUnit] = useState('us')

    useEffect(() => {
        setControlOptions(prev => ({ ...prev, measureUnit: selectedUnit }))
    }, [selectedUnit])

    useEffect(() => { // reset selected unit if active control changes 
        setSelectedUnit(`us`)
    }, [control])

    return (<>
        <span className={`mr-1`}>{control === 'measureArea' ? 'Area' : 'Distance'} Unit:</span> 
        <select 
            value={selectedUnit}
            onChange={e => {
                setSelectedUnit(e && e.target && e.target.value)
            }}
        >
            {control === 'measureArea' 
            ? (<>
                <option value="us" selected>Auto (US)</option>
                <option value="metric">Auto (Metric)</option>
                <option value="ft2">Square Feet</option>
                <option value="ac">Acres</option>
                <option value="m2">Square Meters</option>
                <option value="km2">Square Kilometers</option>
            </>) : (<>
                <option value="us" selected>Auto (US)</option>
                <option value="metric">Auto (Metric)</option>
                <option value="feet">Feet</option>
                <option value="miles">Miles</option>
                <option value="meters">Meters</option>
                <option value="kilometers">Kilometers</option>
            </>)
            }
        </select>
    </>)
}

export default MeasureSelect